<mat-icon class="explain_icon" (click)="openExplanationDialog()">help_outline</mat-icon>
